import { IFrameworkResource } from "../../frameworks";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ITrainingTemplateList } from "../types/ITrainingTemplateList";
import { TrainingTemplateStatus } from "../types/TrainingTemplateStatus";

export interface ITrainingTemplateListQueryParameters
    extends IPaginateable, IOrderable<"name" | "createdAt" | "updatedAt"> {
    filters?: {
        title?: string | null;
        status?: TrainingTemplateStatus | TrainingTemplateStatus[];
        action?: string;
        jobFramework?: RelationalFilter<IFrameworkResource>;
        hasSingleTrainingAction?: boolean;
    };
}

export type ITrainingTemplateListQueryResult = ITrainingTemplateList;

const mapFilters = (filters: ITrainingTemplateListQueryParameters["filters"]) => {
    const { title, status, action, jobFramework, hasSingleTrainingAction } = filters ?? {};

    return {
        name: title,
        status: status,
        action: action,
        "jobFramework.uuid": mapRelationalFilter(jobFramework),
        hasSingleTrainingAction: hasSingleTrainingAction,
    };
};

export const trainingTemplateListQuery: IApiQueryFunction<ITrainingTemplateListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/training_templates${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useTrainingTemplateListQuery = createApiQueryHook<
    ITrainingTemplateListQueryParameters,
    ITrainingTemplateListQueryResult
>(trainingTemplateListQuery);
